import { v4 as uuidv4 } from 'uuid';

export const WEBREG_USER_ID_STORAGE_KEY = 'webregUserId';

export const generateAccessWebregUserId: () => string = () => {
  let userID: string | null = localStorage.getItem(WEBREG_USER_ID_STORAGE_KEY);
  if (!userID) {
    userID = uuidv4();
    localStorage.setItem(WEBREG_USER_ID_STORAGE_KEY, userID as string);
  }
  return userID as string;
};
